import mixpanel from "mixpanel-browser";

import { formatFollowersCount } from "@/Helpers/format-helper";
import { getRandomProfileEmoji, OpenInNewWindow } from "@/Helpers/helper";
import { Button } from "@/shadcnComponents/ui/button";
import { LinkedinIcon, CheckCircleIcon } from "lucide-react";
import { GrAdd } from "react-icons/gr";
import { NoActivePlanAlertButton } from "../Components";

export const SearchInfluencerItemCard = ({
  name,
  profile,
  slug,
  followers,
  LinkedInLink,
  isSelected,
  onClick,
  index,
}) => {
  return (
    <div className="w-full flex items-center justify-between p-2 ">
      <div className="flex gap-3 items-center justify-center ">
        <img
          className="w-[40px] h-[40px] cover rounded-full "
          src={profile}
          alt=""
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          onError={(e: any) => {
            const randomProfileEmoji = getRandomProfileEmoji();
            e.target.onerror = null;
            e.target.src = randomProfileEmoji;
          }}
        />
        <div className="flex flex-col gap-1 ">
          <span
            onClick={() => {
              mixpanel.track(
                "Brand Live/Review Campaign Details: Influencer Live section : Influencer anchors Profile - clicked"
              );
              OpenInNewWindow({
                link: `${window.location.origin}/${slug}`,
              });
            }}
            className="text-[color:var(--Natural-800,#424242)] text-sm not-italic font-semibold leading-5 cursor-pointer"
          >
            {name}{" "}
          </span>
          {followers && (
            <div className="flex gap-1">
              {" "}
              <LinkedinIcon
                className="cursor-pointer"
                onClick={() => {
                  mixpanel.track(
                    "Brand Live/Review Campaign Details: Influencer Live section : Influencer Linkedin - clicked"
                  );
                  OpenInNewWindow({
                    link: LinkedInLink,
                  });
                }}
                size={18}
                color="#DC2627"
              />{" "}
              <span className="text-[#121212] text-sm not-italic font-normal leading-5">
                {formatFollowersCount(parseInt(followers))}
              </span>{" "}
            </div>
          )}
        </div>
      </div>
      <div className="">
        <NoActivePlanAlertButton
          Button={
            <Button
              variant={isSelected ? "secondary" : "default"}
              id={`search_creator_${index}`}
              className={`gap-2 ${
                isSelected ? "text-black" : "text-white"
              } text-xs not-italic font-bold leading-[normal]`}
            >
              {" "}
              {isSelected ? <CheckCircleIcon size={16} /> : <GrAdd />}{" "}
              {/* <span>{isSelected ? "Selected" : "Select Influencers"}</span> */}
            </Button>
          }
          onClick={onClick}
        />
      </div>
    </div>
  );
};
